import React from "react";
import Row from "@components/row";
import { SkeletonBox } from "../../style";

export const OrderDetailsSkeleton = () => {
  return (
    <div style={{ padding: "24px 0" }}>
      {/* Title & Stepper Skeleton */}
      <div style={{ marginBottom: "24px" }}>
        <SkeletonBox
          style={{ width: "200px", height: "32px", marginBottom: "16px" }}
        />
        <SkeletonBox
          style={{ width: "100%", height: "80px", borderRadius: "12px" }}
        />
      </div>

      <Row>
        {/* Left Column: Product Details & History */}
        <div
          style={{
            flex: 3,
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          {/* Product Details Card Skeleton */}
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "24px",
              border: "1px solid #e5e7eb",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <SkeletonBox style={{ width: "150px", height: "24px" }} />
              <SkeletonBox style={{ width: "100px", height: "36px" }} />
            </div>

            {/* Table Header */}
            <div
              style={{
                display: "flex",
                gap: "12px",
                marginBottom: "16px",
                paddingBottom: "12px",
                borderBottom: "1px solid #f3f4f6",
              }}
            >
              <SkeletonBox style={{ width: "40px", height: "20px" }} />
              <div style={{ flex: 1 }}>
                <SkeletonBox style={{ width: "120px", height: "20px" }} />
              </div>
              <SkeletonBox style={{ width: "80px", height: "20px" }} />
              <SkeletonBox style={{ width: "60px", height: "20px" }} />
              <SkeletonBox style={{ width: "60px", height: "20px" }} />
              <SkeletonBox style={{ width: "80px", height: "20px" }} />
            </div>

            {/* Table Rows */}
            {[1, 2].map((i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: "12px",
                  marginBottom: "16px",
                  alignItems: "center",
                }}
              >
                <SkeletonBox style={{ width: "40px", height: "40px" }} />{" "}
                {/* Image placeholder */}
                <div style={{ flex: 1 }}>
                  <SkeletonBox
                    style={{
                      width: "60%",
                      height: "16px",
                      marginBottom: "6px",
                    }}
                  />
                  <SkeletonBox style={{ width: "40%", height: "14px" }} />
                </div>
                <SkeletonBox style={{ width: "80px", height: "16px" }} />
                <SkeletonBox style={{ width: "60px", height: "16px" }} />
                <SkeletonBox style={{ width: "60px", height: "16px" }} />
                <SkeletonBox style={{ width: "80px", height: "16px" }} />
              </div>
            ))}

            {/* Price Breakdown */}
            <div
              style={{
                marginTop: "24px",
                paddingTop: "16px",
                borderTop: "1px dashed #e5e7eb",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: "8px",
              }}
            >
              <SkeletonBox style={{ width: "200px", height: "20px" }} />
              <SkeletonBox style={{ width: "220px", height: "20px" }} />
              <SkeletonBox style={{ width: "180px", height: "20px" }} />
              <SkeletonBox
                style={{ width: "240px", height: "24px", marginTop: "8px" }}
              />
            </div>
          </div>

          {/* History Table Skeleton */}
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}
            >
              <SkeletonBox style={{ width: "180px", height: "24px" }} />
              <SkeletonBox style={{ width: "120px", height: "36px" }} />
            </div>
            <div
              style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid #e5e7eb",
              }}
            >
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    gap: "16px",
                    marginBottom: i === 3 ? 0 : "12px",
                  }}
                >
                  <SkeletonBox style={{ flex: 1, height: "16px" }} />
                  <SkeletonBox style={{ flex: 1, height: "16px" }} />
                  <SkeletonBox style={{ flex: 1, height: "16px" }} />
                  <SkeletonBox style={{ flex: 1, height: "16px" }} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Column: Shipping Info */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {/* Store Info */}
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "16px",
              }}
            >
              <SkeletonBox
                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
              />
              <div style={{ flex: 1 }}>
                <SkeletonBox
                  style={{ width: "60%", height: "16px", marginBottom: "6px" }}
                />
                <SkeletonBox style={{ width: "40%", height: "14px" }} />
              </div>
            </div>
            <SkeletonBox
              style={{ width: "100%", height: "1px", margin: "12px 0" }}
            />
            <SkeletonBox
              style={{ width: "80%", height: "14px", marginBottom: "8px" }}
            />
            <SkeletonBox style={{ width: "70%", height: "14px" }} />
          </div>

          {/* Customer Info */}
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
            }}
          >
            <SkeletonBox
              style={{ width: "120px", height: "20px", marginBottom: "16px" }}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "16px",
              }}
            >
              <SkeletonBox
                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
              />
              <div style={{ flex: 1 }}>
                <SkeletonBox
                  style={{ width: "70%", height: "16px", marginBottom: "6px" }}
                />
                <SkeletonBox style={{ width: "50%", height: "14px" }} />
              </div>
            </div>
            <SkeletonBox
              style={{ width: "100%", height: "40px", borderRadius: "8px" }}
            />
          </div>

          {/* Delivery Info */}
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
            }}
          >
            <SkeletonBox style={{ width: "100%", height: "150px" }} />{" "}
            {/* Map placeholder */}
          </div>
        </div>
      </Row>
    </div>
  );
};
